import * as React from "react";

import { ImageIcon } from "@fluentui/react";
import { LOGO_SRC } from "../../helpers/utils";

export default function Logo({ width = 24, height = 24 }) {
  const src = LOGO_SRC;
  const alt = "logo";
  return <ImageIcon imageProps={{ src, alt, width, height }} />;
}
